import { useMutation, useQueryClient } from '@tanstack/react-query';

import { awardContract } from '../../../common/api/clients/contracts.api';
import { queries } from '../../../common/api/queryKeys/queries';

export const useContractAward = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: awardContract,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: queries.contracts._def }),
    });
};
